import { VoicemailOutlined } from "@mui/icons-material";
import React, { useMemo } from "react";
import AudioPlayerForRouting from "../reusables/AudioPlayerForRouting";
import TooltipComponent from "../reusables/TooltipComponent";
import RouteSelect from "../reusables/RouteSelect";

/**
 * Pure UI component for SendToVoicemail action
 * All logic is handled by useSendToVoicemailAction hook
 */
const SendToVoicemailUI = ({
  recordingValue,
  handleRecordingChange,
  containerClass,
  inputClass,
  headerSize,
  showDivider,
  useIVRStyle,
  setOpenConfigureSlotModal,
  recordings = [],
  hasValidationError = false,
  addRecordingOption,
}) => {
  const recordingOptions = useMemo(() => {
    if (!recordings) return [];
    return recordings.map((item) => ({ value: item.M.rec_id.S, label: item.M.title.S }));
  }, [recordings]);

  // Find the recording URL for audio player
  const recordingUrl = recordingValue
    ? recordings?.find((e) => e.M.rec_id.S === recordingValue)?.M.url.S
    : null;

  // Always use voicemail icon and indigo color regardless of context
  // useIVRStyle only affects layout/styling, not the icon or color
  const Icon = VoicemailOutlined;
  const iconClass = "text-indigo-500"; // Always use indigo (bluish/purple) color
  const title = useIVRStyle ? "Send to a Voicemail" : "Send to Voicemail";
  // Match ForwardUI spacing - always use mb-5 for consistent layout
  const headerMargin = "mb-5";

  return (
    <div>
      <div className={`${containerClass || ""}${hasValidationError ? " !bg-red-50/80" : ""}`}>
        {/* Header */}
        <div className={`flex flex-nowrap items-center justify-between gap-3 ${headerMargin}`}>
          <div className="flex items-center min-w-0 flex-1">
            <Icon className={`${iconClass} shrink-0`} />
            <div className="min-w-0 ml-2">
              <h2 className={`${headerSize} text-gray-800`}>
                {title}
              </h2>
              <div className="text-[13px]">Let callers leave a message</div>
            </div>
          </div>
          {setOpenConfigureSlotModal && (
            <button
              className="shrink-0 whitespace-nowrap text-sm text-blue-600 font-medium hover:underline text-[13px]"
              onClick={() => setOpenConfigureSlotModal(true)}
            >
              ↻ Change
            </button>
          )}
        </div>
        {showDivider && <hr className="border-gray-200 mb-4" />}

        {/* Recording */}
        <div className="mb-4">
          <div className="flex items-center gap-1 mb-1">
            <span className="text-sm font-medium text-gray-700">Recording</span>
            {!useIVRStyle && (
              <TooltipComponent message={"Select the greeting message to play before callers can leave a voicemail"} />
            )}
          </div>
          <RouteSelect
            value={recordingValue || ""}
            onChange={handleRecordingChange}
            options={recordingOptions}
            placeholder="Select a recording"
            addOption={addRecordingOption}
          />
        </div>

        {recordingUrl && (
          <AudioPlayerForRouting src={recordingUrl} />
        )}
      </div>
    </div>
  );
};

export default SendToVoicemailUI;
